<template>
    <div class="row">
        <div v-if="incomingIntent && !isShow"  style="margin-bottom: 5px">
        
            <div class="col-sm-7">
                <div class="row">
                    <div class="col-xs-2 col-sm-1 text-right">
                        <input type="checkbox" name="" id="" @click="$emit('onSelect')" v-model="incomingIntent.selected">
                    </div>
                    <div class="col-xs-10 col-sm-11" style="word-break: break-all;">
                        {{incomingIntent.questiondata}} <template v-if="incomingIntent.count > 1">({{incomingIntent.count}})</template>
                    </div>
                </div>
            </div>
            <div class="visible-xs">
                <br>
            </div>
            <div class="col-xs-12 col-sm-5" style="text-align: right">
                <template v-if="!isShow">
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" style="margin-bottom: 2px;margin-top: 2px;" @click="$emit('onIgnore')">Ignore</a>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" style="margin-bottom: 2px;margin-top: 2px;" @click="isShow = true">Create new</a>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" style="margin-bottom: 2px;margin-top: 2px;" @click="$emit('onAddExistingConversation')">Add existing</a>
                </template>
            </div>

            
            
        </div>
        <div v-if="isShow">
            <div>
                <manage-intent  :type="'add'" v-model="newIntent" @close="onClose"  @saveIntent="onSaveIntent" :excludedIntentName="excludedIntentName"></manage-intent>
            </div>
        </div>
    </div>
</template>

<script>
import ManageIntent from './intent-manage';
    export default {
        props: ['value','excludedIntentName'],
        data: function(){
            return {
                isShow: false,
                newIntent: {
                    intentname: '',
					q_type: 'text',
					a_type : 'text',
					q_val: '',
					a_val: '',
					context_in: '',
                    context_out: '',
                    quick_reply: ''
                },
                incomingIntent: undefined
            }
        },
        components: {
            ManageIntent
        },
        mounted: function(){
            this.incomingIntent = this.value
            this.newIntent.q_val = this.value.questiondata
        },
        methods: {
            onClose: function(){
                var vm  = this
                vm.isShow = false
            },
            onSaveIntent: function(){
                var vm  =this
                var data = {
                    intentname: vm.newIntent.intentname,
                    questiondata: vm.incomingIntent.questiondata
                }
                this.$emit('onSaveTrainingConversation',data)
            },
        },
        watch: {
            value: function(){
                this.incomingIntent = this.value
                this.newIntent.q_val = this.value.questiondata
            }
        }
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/TrainingItem.vue